export class SidenavItem {
    itemName: string;
    itemRouteOrFunction?: any;
    itemIcon?: string;
    itemPosition: number;
    itemPathMatchExact?: boolean;
    itemType?: 'item' | 'subheading';
    itemCustomClass?: string;
    itemSubItems?: SidenavItem[];
    itemParent?: SidenavCategory;
    itemBadge?: string;
    itemBadgeColor?: string;
    isItemActive?: boolean;
    constructor(){
        this.itemName = '';
        this.itemPosition = 0;
    }

    jsonModel(json: any){
        this.itemName = json.itemName;
        this.itemRouteOrFunction =  (json.itemRouteOrFunction) ? json.itemRouteOrFunction : null;
        this.itemIcon = (json.itemIcon) ? json.itemIcon : null;
        this.itemPosition = json.itemPosition;
        this.itemPathMatchExact =  json.itemPathMatchExact ?? false;
        this.itemType = (json.itemType) ? json.itemType : null;
        this.itemCustomClass =  (json.itemCustomClass) ? json.itemCustomClass : null;
        this.itemBadge =  (json.itemBadge) ? json.itemBadge : null;
        this.itemBadgeColor =  (json.itemBadgeColor) ? json.itemBadgeColor : null;
        this.isItemActive = json.isItemActive;

        if (json.itemSubItems) {
            json.itemSubItems.forEach((x: any) => {
                const subMenu = new SidenavItem();
                subMenu.jsonModel(x);
                this.itemSubItems?.push(subMenu);
            });
        } else {
            this.itemSubItems = [];
        }
        if (json.itemParent) {
            this.itemParent = new SidenavCategory();
            this.itemParent.jsonModel(json.itemParent, true);
        } else {
            this.itemParent = undefined;
        }
    }

    getValue(label: string) {
        switch (label) {
            case 'itemName':
                return this.itemName;
            case 'itemRouteOrFunction':
                return this.itemRouteOrFunction;
            case 'itemIcon':
                return this.itemIcon;
            case 'itemPosition':
                return this.itemPosition;
            case 'itemPathMatchExact':
                return this.itemPathMatchExact;
            case 'itemType':
                return this.itemType;
            case 'itemCustomClass':
                return this.itemCustomClass;
            case 'itemBadge':
                return this.itemBadge;
            case 'itemBadgeColor':
                return this.itemBadgeColor;
            case 'itemParent':
                return this.itemParent;
            default:
                break;
        }
    }
}


export class SidenavCategory {
    categoryName: string;
    categoryRouteOrFunction?: any;
    categoryIcon?: string;
    categoryPosition?: number;
    categoryPathMatchExact?: boolean;
    categoryType?: 'item' | 'subheading';
    categoryCustomClass?: string;
    items: SidenavItem[] = [];
    categoryBadge?: string;
    categoryBadgeColor?: string;
    categoryParent?: SidenavCategory;
    isICategoryctive?: boolean;
    constructor(){
        this.categoryName = '';
    }

    jsonModel(json: any,  repetive?: boolean){
        this.categoryName = json.categoryName;
        this.categoryRouteOrFunction =  (json.categoryRouteOrFunction) ? json.categoryRouteOrFunction : null;
        this.categoryIcon = (json.categoryIcon) ? json.categoryIcon : null;
        this.categoryPosition = json.categoryPosition;
        this.categoryPathMatchExact =  json.categoryPathMatchExact ?? false;
        this.categoryType = (json.categoryType) ? json.categoryType : null;
        this.categoryCustomClass =  (json.categoryCustomClass) ? json.categoryCustomClass : null;
        this.categoryBadge =  (json.categoryBadge) ? json.categoryBadge : null;
        this.categoryBadgeColor =  (json.categoryBadgeColor) ? json.categoryBadgeColor : null;
        if (!repetive) { 
            if (json.items) {
                this.items = [];
                const auxItems: SidenavItem[] = [];
                let auxShow: boolean | undefined = false;
                json.items.forEach((x: any) => {
                    const subMenu = new SidenavItem();
                    subMenu.jsonModel(x);
                    auxItems.push(subMenu);
                    auxShow = auxShow || subMenu.isItemActive;
                });
                this.isICategoryctive = (auxItems.length) ? auxShow : true;
                this.items = auxItems.sort((a: SidenavItem, b: SidenavItem) => {
                    if (a.itemPosition < b.itemPosition) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
            } else {
                this.items = [];
            }
        } else {
            this.items = [];
        }

    }
    

    getValue(label: string) {
        switch (label) {
            case 'categoryName':
                return this.categoryName;
            case 'categoryRouteOrFunction':
                return this.categoryRouteOrFunction;
            case 'categoryIcon':
                return this.categoryIcon;
            case 'categoryPosition':
                return this.categoryPosition;
            case 'categoryPathMatchExact':
                return this.categoryPathMatchExact;
            case 'categoryType':
                return this.categoryType;
            case 'categoryCustomClass':
                return this.categoryCustomClass;
            case 'items':
                return this.items;
            case 'categoryBadge':
                return this.categoryBadge;
            case 'categoryBadgeColor':
                return this.categoryBadgeColor;
            case 'categoryParent':
                return this.categoryParent;
            default:
                break;
        }
    }
}


export class SidenavRol {
    categories: SidenavCategory[];
    isActiveRol: boolean;
    rolName: string;
    constructor(){
        this.categories = [];
        this.isActiveRol = false;
        this.rolName = '';
    }
    jsonModel(json: any){
        this.isActiveRol = json.isActiveRol;
        this.rolName =  (json.rolName) ? json.rolName : 'null';
        if (json.categories) {
            this.categories = [];
            json.categories.forEach((x: any) => {
                const subMenu = new SidenavCategory();
                subMenu.jsonModel(x);
                this.categories.push(subMenu);
            });
        } else {
            this.categories = [];
        }
    }
}

export class SidenavMenu {
    isUserActive: boolean;
    rol: SidenavRol | null;
    userEmail: string;
    userName: string;

    constructor(){
        this.isUserActive = false;
        this.rol = null;
        this.userEmail = '';
        this.userName = '';
    }
    jsonModel(json: any){
        this.isUserActive = json.isUserActive;
        this.userName =  (json.userName) ? json.userName : 'null';
        this.userEmail =  (json.userEmail) ? json.userEmail : 'null';
        if (json.rol) {
            this.rol = new SidenavRol();
            this.rol.jsonModel(json.rol);
        } else {
            this.rol = null;
        }
    }
}